import HttpService from '../baseHttp';

// 部门管理列表
export const HttpGetDeptList = (data = {}) => HttpService.get('/api/v1/UcDepartment/findAll', { params: data, baseURL: process.env.VUE_APP_APIURL_UC });
// 下级部门列表
export const HttpGetChildrenDeptList = (data = {}) => HttpService.get('/api/v1/UcDepartment/findAllByParent', { params: data, baseURL: process.env.VUE_APP_APIURL_UC });
// 批量删除部门
export const HttpBatchDeleteDept = (data = {}, config) => HttpService.post('/api/v1/UcDepartment/batchDel', data, { baseURL: process.env.VUE_APP_APIURL_UC } )
// 新增、修改部门
export const HttpAddDept = (data = {}, config) => HttpService.post('/api/v1/UcDepartment/save', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_UC, params: config } )
// 部门详情
export const HttpGetDeptDetail = (data = {}) => HttpService.get('/api/v1/UcDepartment/detail', { params: data, baseURL: process.env.VUE_APP_APIURL_UC });
// 检查部门编号是否已经存在
export const HttpCheckDeptExist = (data = {}) => HttpService.get('/api/v1/UcDepartment/checkCodeExists', { params: data, baseURL: process.env.VUE_APP_APIURL_UC });
// 当前部门员工列表
export const HttpGetStaffList = (data = {}) => HttpService.get('/api/v1/UcDepartmentEmployee/selectByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_UC });
// 员工详情
export const HttpGetStaffDetail = (data = {}) => HttpService.get('/api/v1/UcDepartmentEmployee/getDetail', { params: data, baseURL: process.env.VUE_APP_APIURL_UC });
// 新增、修改员工
export const HttpAddStaff = (data = {}, config) => HttpService.post('/api/v1/UcDepartmentEmployee/save', data, { headers: { "Content-Type": "application/json" }, baseURL: process.env.VUE_APP_APIURL_UC, params: config } )
// 批量删除员工
export const HttpBatchDeleteStaff = (data = {}, config) => HttpService.post('/api/v1/UcDepartmentEmployee/batchDel', data, { baseURL: process.env.VUE_APP_APIURL_UC } )
// 所有员工列表
export const HttpGetAllStaffList = (data = {}) => HttpService.get('api/v1/User/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_UC });
